import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig, MatSnackBarRef, MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from '../dialogs/alert.component';
import { Multimedia } from '../_models/comparador/multimedia';
import { MultimediaComponent } from '../comparador/components/multimedia/multimedia.component';
import { BorrarArchivoDialog } from '../dialogs/comparador/borrar-archivo/borrar-archivo.dialog';
import { SnackBarInfoComponent } from '../dialogs/snackbar-info/snackbar-info.component';

@Injectable()
export class DialogService {
	constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

	/**
	 * Abre un snackBar para borrar archivo multimedia con los parámetros dados
	 * @function
	 * @param {Multimedia} archivo - Archivo a borrar
	 */
	abrirSnackBarBorrarArchivo(
		archivo: Multimedia,
		multimediaComponent: MultimediaComponent
	): void {
		let config = new MatSnackBarConfig();

		let snackRef: MatSnackBarRef<BorrarArchivoDialog> = this.snackBar.openFromComponent(
			BorrarArchivoDialog,
			config
		);
		snackRef.instance.archivo = archivo;
		snackRef.instance.snackBarRef = snackRef;
		snackRef.instance.multimediaComponent = multimediaComponent;
		snackRef.instance.dialogService = this;
	}

	abrirSnackBarInformacion(
		titulo: string,
		mensaje: string,
		duracion: number,
		textoBoton: string = null,
		funcion: any = null
	): void {
		let config = new MatSnackBarConfig();
		if (duracion != null) config.duration = duracion;
		let snackRef: MatSnackBarRef<SnackBarInfoComponent> = this.snackBar.openFromComponent(
			SnackBarInfoComponent,
			config
		);
		snackRef.instance.titulo = titulo;
		snackRef.instance.mensaje = mensaje;
		snackRef.instance.snackBarRef = snackRef;
		snackRef.instance.textoBoton = textoBoton;
		snackRef.instance.funcion = funcion;
	}
}
